import { useQuery } from '@tanstack/react-query';

// helpers
import { BaseError } from '../../helpers/BaseError';

// models
import { SurfaceModal } from '../../models/surface.model';

// services
import API from '../../services/api';

// constants
import surfaceKeys from './_queryKeys';

const getSurface = async (surfaceId: string): Promise<SurfaceModal> => {
    const { data } = await API.fetchSurface(surfaceId);
    return data;
};

export default function useSurfaceQuery(surfaceId: string) {
    return useQuery<SurfaceModal, BaseError>({
        queryKey: surfaceKeys.getSurface(surfaceId),
        queryFn: () => getSurface(surfaceId),
        enabled: !!surfaceId,
    });
}
